var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "cf-panel cf-panel-lg",
      staticStyle: { display: "block" },
      attrs: { id: "formats-all-container" },
    },
    [
      _vm.loading ? _c("Spinner", { staticClass: "lg overlay" }) : _vm._e(),
      _vm._v(" "),
      _c("h2", [_vm._v("Your import formats")]),
      _vm._v(" "),
      _c("table", { staticClass: "table corpora" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.formats, function (f) {
            return _c("tr", [
              _c("td", [_vm._v(_vm._s(f.shortId))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(f.displayName))]),
              _vm._v(" "),
              _c("td", [
                _c("a", {
                  staticClass: "fa fa-fw fa-pencil",
                  attrs: {
                    role: "button",
                    title: `Edit format '${f.displayName}'`,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("edit", f.id)
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("td", [
                _c("a", {
                  staticClass: "fa fa-fw fa-trash",
                  attrs: {
                    role: "button",
                    title: `Delete format '${f.displayName}'`,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("delete", f.id)
                    },
                  },
                }),
              ]),
            ])
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-lg btn-default",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("create")
            },
          },
        },
        [_vm._v("New format")]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Id")]),
        _vm._v(" "),
        _c("th", [_vm._v("Name")]),
        _vm._v(" "),
        _c("th", { staticClass: "table-icon" }),
        _vm._v(" "),
        _c("th", { staticClass: "table-icon" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }